var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "delivery-track-wrapper bj",
    },
    [
      _c(
        "div",
        { staticClass: "track-content" },
        _vm._l(_vm.trackData, function (item, key) {
          return _c(
            "div",
            { key: key, staticClass: "track-column" },
            [
              _c("h2", { staticClass: "column-header" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      item.is_morning === 1
                        ? "早市仓" + ("（" + item.morning_time + `前` + "）")
                        : "午市仓"
                    ) +
                    " "
                ),
              ]),
              _c(
                "el-card",
                { staticClass: "track-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("品控进度"),
                  ]),
                  _c("div", { staticClass: "progress-section" }, [
                    _c("span", { staticClass: "percent-num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.calculatePercent(item.partial_num, item.total_num)
                        ) + "%"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "progress-bar" },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.calculatePercent(
                              item.partial_num,
                              item.total_num
                            ),
                            "show-text": false,
                            "stroke-width": 12,
                            color: "#409EFF",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "data-row" }, [
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 共："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.total_num || 0)),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 已品控："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.partial_num || 0)),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-card",
                { staticClass: "track-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("复核进度"),
                  ]),
                  _c("div", { staticClass: "progress-section" }, [
                    _c("span", { staticClass: "percent-num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.calculatePercent(item.qc_number, item.total_num)
                        ) + "%"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "progress-bar" },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.calculatePercent(
                              item.qc_number,
                              item.total_num
                            ),
                            "show-text": false,
                            "stroke-width": 12,
                            color: "#409EFF",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "data-row" }, [
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 共："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.total_num || 0)),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 已复核："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.parseNumber(item.qc_number))),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                  ]),
                  _c("div", { staticClass: "data-row mt-10" }, [
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 共："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.supplier_order_count || 0)),
                      ]),
                      _vm._v(" 单 "),
                    ]),
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 已复核："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.qc_count || 0)),
                      ]),
                      _vm._v(" 单 "),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-card",
                { staticClass: "track-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("超 2 小时未送货"),
                  ]),
                  _c("div", { staticClass: "progress-section" }, [
                    _c("span", { staticClass: "percent-num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.calculatePercent(
                            item.quality_control_count,
                            item.supplier_order_count
                          )
                        ) + "%"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "progress-bar" },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.calculatePercent(
                              item.quality_control_count,
                              item.supplier_order_count
                            ),
                            "show-text": false,
                            "stroke-width": 12,
                            color: "#409EFF",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "data-row" }, [
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 共："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.supplier_order_count || 0)),
                      ]),
                      _vm._v(" 单 "),
                    ]),
                    _c("div", { staticClass: "data-item danger" }, [
                      _vm._v(" 超时："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.quality_control_count || 0)),
                      ]),
                      _vm._v(" 单 "),
                    ]),
                  ]),
                  _c("div", { staticClass: "data-row mt-10" }, [
                    _c("div", { staticClass: "data-item" }, [
                      _vm._v(" 共："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.total_num || 0)),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                    _c("div", { staticClass: "data-item danger" }, [
                      _vm._v(" 超时："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(
                          _vm._s(_vm.parseNumber(item.quality_control_num))
                        ),
                      ]),
                      _vm._v(" 件 "),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }